import React, { useState } from "react";
import PropTypes from "prop-types";
import ToolBar from "../../elements/ToolBar";

import { initReactI18next, useTranslation } from "react-i18next";
import i18n from "i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";

import "../../../components/elements/History/history-item.css";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const ToolbarButton = ({ isDrawerOpen, toggleDrawer }) => {
  const { t } = useTranslation();

  return !isDrawerOpen ? (
    <button
      data-testid="toolbar-button-show"
      className="show-toolbar"
      onClick={toggleDrawer}
    >
      <p>{t("show_toolbar")}</p>
    </button>
  ) : (
    <button
      data-testid="toolbar-button-hide"
      className="hide-toolbar"
      onClick={toggleDrawer}
    >
      <p>{t("hide_toolbar")}</p>
    </button>
  );
};

ToolbarButton.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
};

const SideToolBar = () => {
  let jwtToken = localStorage.getItem("token") || null;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    console.log("Toggle Drawer");

    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      {jwtToken !== null && (
        <>
          <ToolbarButton
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
          />
          <div className="z-1">
            <ToolBar
              drawerState={isDrawerOpen}
              isLogin={jwtToken !== null}
            />
          </div>
        </>
      )}
    </>
  );
};

export default SideToolBar;
